import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import loginValidator from "validators/login.validator";
import { ILoginInput } from "models/auth";
import { loginApi } from "api/auth";
import { useNotificationContext } from "contexts/NotificationContext";
import { useNavigate } from "react-router-dom";
import { RouteName } from "constants/route";
import { jwtDecode } from "jwt-decode";
import { ERole } from "models/account";

export default function useLogin() {
  const navigate = useNavigate();
  const { showError, showSuccess } = useNotificationContext();
  const [loading, setLoading] = useState<boolean>(false);
  const { control, handleSubmit } = useForm<ILoginInput>({
    resolver: yupResolver(loginValidator),
  });

  useEffect(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
  }, []);

  const accountDashboard = (role: ERole) => {
    switch (role) {
      case ERole.ADMIN:
      case ERole.SUPER_ADMIN:
      case ERole.DISPATCH:
        return RouteName.DASHBOARD;
      case ERole.CASHER:
        return RouteName.DRIVER;
      case ERole.POLICE:
        return RouteName.DRIVER_SEARCH;
      default:
        return RouteName.TRIP;
    }
  };

  const onSubmit = async (input: ILoginInput) => {
    setLoading(true);
    const { data, error } = await loginApi(input);
    if (data) {
      const role: ERole = (jwtDecode(data.token.access_token) as any).role;
      localStorage.setItem("token", data.token.access_token);
      showSuccess("Successfully logged in");
      if (data.data.password_change_required)
        navigate(RouteName.CHANGE_PASSWORD);
      else navigate(accountDashboard(role), { replace: true });
    } else {
      showError(error!.message);
    }
    setLoading(false);
  };

  return { handleSubmit, onSubmit, control, loading };
}
